import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { useMemo } from 'react';
import { useZIndex } from '../ZIndexProvider/ZIndexProvider';
import { toast } from './toast';

const {
  primary,
  secondary,
  success,
  warning,
  danger
} = toast,
      otherToastMethods = _objectWithoutPropertiesLoose(toast, ["primary", "secondary", "success", "warning", "danger"]);

const useToast = () => {
  const zIndex = useZIndex(null);
  return useMemo(() => Object.assign({
    primary: (content, options) => primary(content, Object.assign({
      zIndex
    }, options)),
    secondary: (content, options) => secondary(content, Object.assign({
      zIndex
    }, options)),
    success: (content, options) => success(content, Object.assign({
      zIndex
    }, options)),
    warning: (content, options) => process.env.NODE_ENV !== "production" ? warning(content, Object.assign({
      zIndex
    }, options)) : void 0,
    danger: (content, options) => danger(content, Object.assign({
      zIndex
    }, options))
  }, otherToastMethods), [zIndex]);
};

export { useToast };